import styled from 'styled-components';

export const Container = styled.div``;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  gap: 1rem;
`;

export const ServiceDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding-bottom: 2rem;
  width: 100%;
`;

export const DivInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  text-align: left;
`;

export const OpenTicket = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
  width: 100%;

  @media screen and (max-width: ${({ theme }) => theme.size?.medium}) {
    flex-direction: column;
    align-items: stretch;
    gap: 1.5rem;
  }
`;

export const KeyValue = styled.div`
  display: flex;
  gap: 0.5rem;
  @media screen and (max-width: ${({ theme }) => theme.size?.xxlarge}) {
    flex-direction: ${({ theme }) =>
      theme.fontSizeType == 'xLarge' || theme.fontSizeType == 'large'
        ? 'column'
        : 'row'};
  }
  @media screen and (max-width: ${({ theme }) => theme.size?.xlarge}) {
    flex-direction: column;
  }
`;

export const DivButtonTicket = styled.div`
  display: flex;
  flex-shrink: 0;
  align-self: center;
  margin-left: auto;

  @media screen and (max-width: ${({ theme }) => theme.size?.medium}) {
    align-self: flex-end;
  }
`;

export const DivAlert = styled.div`
  margin-top: 2rem;
`;

export const P = styled.h6``;

export const B = styled.h6`
  height: 1rem;
  font-weight: bold;
`;

export const A = styled.a``;
